import React from 'react';

type TChatContext = {
  onPickerItemSelect?: (item: connect.ListPickerItem, redirect: boolean) => void;
};

export const ChatContext = React.createContext<TChatContext>({});

export const useChatContext = () => React.useContext(ChatContext);
